import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=977d8d28&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "../../theme/card.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Card.vue?vue&type=style&index=1&id=977d8d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977d8d28",
  null
  
)

export default component.exports